import React, { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { LoginLeftView } from "./loginLeftView";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import RFSLogoFullColour from "../../asset/RFSLogoFullColour.png";
import { loginUser, clearVerification } from "../../store/actions";
import { Wrapper, RightWrapper } from "./styled";
import {
  Form,
  FormGroup,
  Input,
  Label,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap";

const Login = ({ setLastActivity }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const { isLoading } = auth;

  const data = {
    email: "",
    password: "",
  };
  const [passwordShown, setPasswordShown] = useState(false);
  const [emailError, setError] = useState(false);
  const [formData, setformData] = useState(data);

  useEffect(() => {
    dispatch(clearVerification());
    // eslint-disable-next-line
  }, [])

  const togglePassword1 = () => {
    setPasswordShown(!passwordShown);
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleChange = (e) => {
    setError(false);
    const { name, value } = e.target;
    setformData({
      ...formData,
      [name]: value,
    });
  };

  const handleUserSubmit = (e) => {
    e.preventDefault();
    setError(false);
    const { email, password } = formData;
    if (!isValidEmail(email)) {
      return setError(true);
    }
    let data = {
      email: email.toLowerCase(),
      password,
      platformType: "WEB",
      platform: "TREASURY",
      deviceType: 'WEB',
    };
    setLastActivity(Date.now());
    dispatch(loginUser(data, navigate, dispatch));
  };

  return (
    <>
      <div>
        <Toaster />
      </div>
      <Wrapper>
        <div className="content">
          <div className="login-left-view">
            <LoginLeftView />
          </div>

          <div className="login-right-view">
            <div className="login-right-inner">
              <RightWrapper>
                <div className="rosabonLogo">
                  <img
                    style={{ width: "70px", height: "30px" }}
                    src={RFSLogoFullColour}
                    alt="RFSLogo"
                  />
                </div>
                <h4 className="container">Login</h4>
                <div className="container">
                  <Form autoComplete="off" onSubmit={handleUserSubmit}>
                    <FormGroup className="w-100">
                      <Label
                        htmlFor="email"
                        className="card-title fw-bold fs-5 mb-2"
                      >
                        Email Address
                      </Label>
                      <Input
                        type="email"
                        name="email"
                        className="w-100"
                        bsSize="lg"
                        onChange={handleChange}
                        invalid={emailError}
                      />
                      <FormFeedback>Valid Email is Required</FormFeedback>
                    </FormGroup>
                    <FormGroup className="w-100">
                      <Label
                        htmlFor="email"
                        className="card-title fw-bold fs-5 mb-2"
                      >
                        Password
                      </Label>
                      <InputGroup>
                        <Input
                          type={passwordShown ? "text" : "password"}
                          bsSize="lg"
                          onChange={handleChange}
                          name="password"
                          value={formData.password}
                        />
                        <InputGroupText>
                          <i
                            onClick={togglePassword1}
                            style={{ cursor: "pointer" }}
                            className={
                              passwordShown ? "far fa-eye" : "far fa-eye-slash"
                            }
                          ></i>
                        </InputGroupText>
                      </InputGroup>
                      <FormFeedback>Password</FormFeedback>
                    </FormGroup>
                    <div className="d-flex justify-content-between align-items-center">
                      <FormGroup check>
                        <Input type="checkbox" />
                        <Label check>Stay signed in</Label>
                      </FormGroup>
                      <span className="card-title">
                        <Link to="/forgot-password">Forgot Password?</Link>
                      </span>
                    </div>
                    <div className="text-center mt-5">
                      <button
                        type="submit"
                        className="btn btn-primary px-5 mb-2"
                        disabled={isLoading}
                      >
                        {isLoading ? "LOADING..." : "Login"}
                      </button>
                      <p>
                        Don't have an account?{" "}
                        <span className="">
                          <Link to="/register-user">Sign up</Link>
                        </span>
                      </p>
                    </div>
                  </Form>
                </div>
              </RightWrapper>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default Login;
